import { useAuth } from '@barboxx/admin-utils';

import { RootContainer } from '../components/nav/RootContainer';
import { BusinessDashboard } from './BusinessDashboard';
import { InternalDashboard } from './InternalDashboard';

export function Dashboard() {
    const { auth } = useAuth();
    return (
        <RootContainer maxWidth={false}>
            {auth.user.userType === 'Internal' ? (
                <InternalDashboard />
            ) : (
                <BusinessDashboard />
            )}
        </RootContainer>
    );
}
